import React, { useEffect, useState } from "react";

import css from "./SkeletonRect.module.scss";

export type SkeletonRectProps = {
  width: string;
  height: string;
};

export const SkeletonRect: React.FC<SkeletonRectProps> = ({ ...props }) => {
  return <div style={props} className={css.SkeletonRect} />;
};
